"use client"
import { InputProps } from '@copilotkit/react-ui'
import React, { useRef, useState } from 'react'
import SendIcon from '@mui/icons-material/Send';
import { Box, Typography } from '@mui/material';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import { useTranslations } from 'next-intl';
const Input = ({ inProgress, onSend, isVisible }: InputProps) => {
    const t = useTranslations("messages");
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const [valueTextArea, setValueTextArea] = useState<string>("");
    const handleSubmit = (value: string) => {
        if (value.trim()) onSend(value);
    };
    const handleClearChat = () => {
        setValueTextArea('');
    }
    return (
        <Box className="flex flex-col gap-4 pt-6 pb-8 px-6">
            <Box sx={{
                boxShadow: "0px 0px 2px 0px #0000001A"
            }} className={"flex gap-[10px] p-4 rounded-[8px] !border border-solid !border-[#D2D2D2] focus:outline-none focus:border-blue-500"}>
                <textarea
                    value={valueTextArea}
                    ref={textareaRef}
                    translation-key="copilotkit_assistant_input_placeholder"
                    placeholder={t("copilotkit_assistant_input_placeholder")}
                    className={"flex-1 border-none focus:outline-none font-[Montserrat] resize-none text-[15px] leading-[24px] font-semibold text-[var(--gray-90)]"}
                    onChange={(e: any) => setValueTextArea(e.target.value)}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            e.preventDefault(); // Ngăn xuống dòng
                            handleSubmit(e.currentTarget.value);
                            setValueTextArea('');
                        }
                    }}
                />

                <Box sx={{
                    borderLeft: "2px solid #E0E0E0",
                }} className="flex !m-0 items-center">
                    <button
                        disabled={inProgress}
                        className={" pr-4 pl-5 py-2 w-full h-full p-0 bg-transparent text-[#A4A4A4] border-none hover:text-[#7A7A7A] cursor-pointer disabled:cursor-not-allowed"}
                        onClick={() => {
                            const input = textareaRef.current;
                            if (input) {
                                handleSubmit(input.value);
                                input.value = '';
                                setValueTextArea('');
                                input.focus();
                            }
                        }}
                    >
                        <SendIcon className="w-6 h-6" />
                    </button>
                </Box>
            </Box>
            <Box className="flex gap-3">
                <Box className="flex-1">
                </Box>
                <Box>
                    {
                        valueTextArea ?
                            (
                                <button className="flex gap-2 border-none bg-transparent items-center cursor-pointer group " onClick={handleClearChat}>
                                    <RefreshRoundedIcon className="w-4 h-4 text-[#767676] group-hover:!text-[#585858]" />
                                    <Typography translation-key="copilotkit_assistant_clear_chat" component="span" className=" !text-[14px] !font-[Montserrat] !font-semibold text-[#767676] group-hover:!text-[#585858]">
                                        {t("copilotkit_assistant_clear_chat")}
                                    </Typography>
                                </button>
                            ) :
                            null
                    }
                </Box>
            </Box>
        </Box>
    )
}

export default Input